import {
  ALL,
  ACTION_REQUIRED,
  UNDER_REVIEW,
  EXPIRED,
  CHECKBOX,
  VERIFIED,
} from 'baseConfig/pg/constants';
import { CANCELLED } from 'utils/constants';

const COMMON_COLUMNS = [
  {
    key: 'initiatedAt',
    displayName: 'Initiated At',
  },
  {
    key: 'paymentDate',
    displayName: 'Payment Date',
  },
  {
    key: 'paymentId',
    displayName: 'Payment ID',
  },
  {
    key: 'paymentAmount',
    displayName: 'Payment Amt.',
    align: 'right',
  },
  {
    key: 'paymentMethod',
    displayName: 'Payment Method',
  },
  {
    key: 'customerPhoneNumber',
    displayName: 'Phone No.',
  },
];

const PAYMENT_VERIFICATIONRESPOND_BY_ITEMS = {
  TODAY: 'Today',
  TOMORROW: 'Tomorrow',
  NEXT_SEVEN_DAYS: 'Next 7 days',
  NEXT_THIRTY_DAYS: 'Next 30 days',
  OVERDUE: 'Overdue',
  DUE_IMMEDIATE_WEEKEND: 'Due Immediate Weekend',
};

const PAYMENT_STATUS_ITEMS = {
  ACTION_REQUIRED: 'Action Required',
  IN_REVIEW: 'In Review',
  VERIFIED: 'Verified',
  EXPIRED: 'Expired',
  CANCELLED: 'Cancelled',
};

const PAYMENT_VERIFICATION_STATUS = {
  displayText: 'Status',
  type: CHECKBOX,
  items: PAYMENT_STATUS_ITEMS,
};

const PAYMENT_VERIFICATION_RESPOND_BY = {
  displayText: 'Respond By',
  type: CHECKBOX,
  items: PAYMENT_VERIFICATIONRESPOND_BY_ITEMS,
};

const COMMON_FILTERS = {
  statuses: PAYMENT_VERIFICATION_STATUS,
  respondBy: PAYMENT_VERIFICATION_RESPOND_BY,
};

const COMMON_SEARCH_ITEMS = [
  {
    key: 'paymentId',
    text: 'Payment ID',
    value: 'paymentId',
    placeholder: 'Enter Payment ID',
    inputPattern: '^[0-9,]+$',
    error: 'Only numbers and comma are allowed.',
  },
  {
    key: 'phoneNumber',
    text: 'Phone Number',
    value: 'customerPhone',
    placeholder: 'Enter Phone Number',
    inputPattern: '^[0-9 +-]+$',
    maxLength: 14,
    error:
      'Only numbers and special characters (space, plus, hyphen) are allowed.',
  },
  {
    key: 'customerName',
    text: 'Customer Name',
    value: 'customerName',
    placeholder: 'Enter Customer Name',
    inputPattern: '^[a-zA-Z ]+$',
    error: 'Only alphabets and space are allowed.',
  },
];

export default {
  [ACTION_REQUIRED]: {
    TABLE_COLUMNS: [
      ...COMMON_COLUMNS,
      {
        key: 'expiryDateTime',
        displayName: 'Verification Due By',
      },
      {
        key: 'action',
        displayName: 'Action',
        width: 1.7,
      },
    ],
    FILTER_ITEMS: { ...COMMON_FILTERS },
    SEARCH_ITEMS: [...COMMON_SEARCH_ITEMS],
  },
  [UNDER_REVIEW]: {
    TABLE_COLUMNS: [...COMMON_COLUMNS],
    FILTER_ITEMS: { ...COMMON_FILTERS },
    SEARCH_ITEMS: [...COMMON_SEARCH_ITEMS],
  },
  [VERIFIED]: {
    TABLE_COLUMNS: [...COMMON_COLUMNS],
    FILTER_ITEMS: { ...COMMON_FILTERS },
    SEARCH_ITEMS: [...COMMON_SEARCH_ITEMS],
  },
  [EXPIRED]: {
    TABLE_COLUMNS: [
      ...COMMON_COLUMNS,
      {
        key: 'expiryDateTime',
        displayName: 'Expired On',
      },
    ],
    FILTER_ITEMS: { ...COMMON_FILTERS },
    SEARCH_ITEMS: [...COMMON_SEARCH_ITEMS],
  },
  [ALL]: {
    TABLE_COLUMNS: [
      ...COMMON_COLUMNS,
      {
        key: 'verificationStatus',
        displayName: 'Verification Status',
      },
      {
        key: 'expiryDateTime',
        displayName: 'Due By',
      },
      {
        key: 'action',
        displayName: 'Action',
        width: 1.6,
      },
    ],
    FILTER_ITEMS: { ...COMMON_FILTERS },
    SEARCH_ITEMS: [...COMMON_SEARCH_ITEMS],
  },
};
